import '@inbox-demo-nx/theme';

import AutoUpdatingTimestamp from '@inbox-demo-nx/ui-auto-updating-timestamp';
import { ChannelBadge } from '@inbox-demo-nx/ui-badges';
import { ChannelCover } from '@inbox-demo-nx/ui-chat-common';
import ListItem from '@inbox-demo-nx/ui-list-item';
import {
  AnySendBirdMessage,
  getChannelUpdatedAt,
  getLastMessage,
  useGetChannelTitle,
} from '@inbox-demo-nx/utils-chat-common';
import { Text, useDripsyTheme, useSx, View } from 'dripsy';
import { StyleSheet } from 'react-native';
import SendBird from 'sendbird';

export default function ChannelListItem({
  onPress,
  channel,
  getLastMessage: getLastMessageProp,
}: {
  onPress: () => void;
  channel: SendBird.GroupChannel;
  getLastMessage?: (channel: SendBird.GroupChannel) => string;
}) {
  const sx = useSx();
  const { theme } = useDripsyTheme();
  const getChannelTitle = useGetChannelTitle({ addMemberCount: true });
  const handlePress = () => {
    if (channel.isFrozen) {
      return;
    }
    onPress();
  };

  return (
    <ListItem viewStyle={_styles.inboxItem} onPress={handlePress}>
      <ChannelCover
        channel={channel}
        size={theme.sizes.channelListAvatar}
        style={{ position: 'relative', marginRight: 16 }}
      />
      <View style={{ flex: 1 }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
          }}
        >
          <View
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Text
              ellipsizeMode="tail"
              numberOfLines={1}
              sx={{ variant: 'styles.channelListItemTitle' }}
            >
              {getChannelTitle(channel)}
            </Text>
            <ChannelBadge
              channel={channel}
              color={theme.colors.text}
              style={{ marginLeft: 4 }}
            />
          </View>
          <AutoUpdatingTimestamp
            value={getChannelUpdatedAt(channel)}
            style={sx({ variant: 'styles.channelListTimestamp' })}
          />
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
          }}
        >
          <View style={{ flex: 1 }}>
            <Text
              sx={{ variant: 'styles.channelListItemMessage' }}
              ellipsizeMode="tail"
              numberOfLines={2}
            >
              {getLastMessageProp?.(channel) || getLastMessage(channel)}
            </Text>
          </View>
          {channel.unreadMessageCount > 0 && (
            <View style={_styles.badge} sx={{ backgroundColor: 'badge' }}>
              <Text
                sx={{
                  color: 'white',
                  textAlign: 'center',
                  fontSize: 'xsmall',
                  fontWeight: 'bold',
                }}
              >
                {channel.unreadMessageCount}
              </Text>
            </View>
          )}
        </View>
      </View>
    </ListItem>
  );
}

const _styles = StyleSheet.create({
  badge: {
    height: 20,
    minWidth: 20,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 24,
  },
  inboxItem: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
});
